/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navcases1Inputs */

const en_navcases1 = /** @type {(inputs: Navcases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

const pt_navcases1 = /** @type {(inputs: Navcases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos`)
};

/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Navcases1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const navcases1 = /** @type {((inputs?: Navcases1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navcases1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navcases1(inputs)
	return pt_navcases1(inputs)
});
export { navcases1 as "navCases" }